import * as types from '../constants';
import store from 'store';

const token = store.get('token');

const initialState = {
  isAuthenticated: !!token,
  pageLoading: true,
  error: false,
  success: true,
  payload: {
    token
  },
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.LOGIN_START:
      return {
        ...state,
        pageLoading: true,
        error: false,
        success: true,
      };

    case types.SIGNUP_START:
      return {
        ...state,
        pageLoading: true,
        error: false,
        success: true,
      };

    case types.CONFIRM_START:
      return {
        ...state,
        pageLoading: true,
      };

    case types.LOGIN_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        payload: action.payload,
        error: false,
        success: true,
        isAuthenticated: true
      };

    case types.SIGNUP_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        payload: action.payload,
        success: true,
      };

    case types.LOGIN_FAILURE:
      return {
        ...state,
        pageLoading: true,
        error: action.error,
        success: false,
        isAuthenticated: false
      };

    case types.SIGNUP_FAILURE:
      return {
        ...state,
        pageLoading: true,
        error: action.error,
        success: false,
      };

    case types.CONFIRM_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        error: false,
        payload: {
          ...state.payload,
          token: action.payload.token
        },
        isAuthenticated: true
      };

    case types.CONFIRM_FAILURE:
      return {
        ...state,
        pageLoading: false,
        error: action.error,
        isAuthenticated: false
      };

    case types.RESET_PASSWORD_START:
      return {
        ...state,
        payload: {},
        success: true,
        error: false,
        pageLoading: true,
      };

    case types.RESET_PASSWORD_SUCCESS:
      return {
        ...state,
        pageLoading: false,
        success: true,
        error: false,
        payload: action.payload,
      };

    case types.RESET_PASSWORD_FAILURE:
      return {
        ...state,
        pageLoading: true,
        success: false,
        error: action.error,
      };

    case types.LOGOUT:
      return {
        ...state,
        isAuthenticated: false,
      };

    default:
      return state;
  }
};

export default reducer;
